<div class="recommend">
  <h2>Usuários Indicados: {{invitedUsers}}</h2>
  <h3>Extrato</h3>
  <div class="recommend__table">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef> Data </th>
        <td mat-cell *matCellDef="let element"> {{element.date}} </td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Descrição </th>
        <td mat-cell *matCellDef="let element"> {{element.description}} </td>
      </ng-container>
      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef> Valor R$ </th>
        <td mat-cell *matCellDef="let element"> {{(element.value / 100).toFixed(2).replace('.',',')}} </td>
      </ng-container>
      <ng-container matColumnDef="points">
        <th mat-header-cell *matHeaderCellDef> Pontos </th>
        <td mat-cell *matCellDef="let element"> {{(element.points / 100).toFixed(2).replace('.',',')}} </td>
      </ng-container>
      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef> Acumulado </th>
        <td mat-cell *matCellDef="let element"> {{(element.total / 100).toFixed(2).replace('.',',')}} </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.status === 'Crédito' || element.status === 'Pendente'">{{element.status}}</span>
          <span *ngIf="element.status === 'Transferido'">{{element.status}} <br /> {{element.paid}}</span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
    </table>
    <div>
      <mat-paginator fxLayoutAlign="end end" [length]="page.totalElements" [pageSize]="page.per_page"
        [pageSizeOptions]="pageSizeOptions" [pageIndex]="page.current_page" showFirstLastButtons
        (page)="pageEvent = getExtract($event)"></mat-paginator>
    </div>
  </div>
  <div class="recommend__pix mt-5">
    <h3>Solicitação</h3>
    <div class="recommend__pix__body">
      <p>Seus pontos <strong>{{(userTotal/ 100).toFixed(2).toString().replace('.',',')}}</strong> serão transformados em
        moeda REAIS <strong>(R$
          {{(userTotal/ 100).toFixed(2).toString().replace('.',',')}})</strong> e
        transferidos para sua conta via PIX. A
        TRANSFERÊNCIA será realizada em até <strong>48h</strong>. O TÍTULAR da conta bancária precisar ser o mesmo
        <strong>TÍTULAR</strong> da conta na
        Plataforma ESCRITHA.
      </p>

      <p class="font-italic">
        (Obs: Solicitação miníma de R$ 20,00).
      </p>

      <p>Para solicitar a transferência, clique no botão abaixo e preencha os campos solicitados.</p>
      <div [formGroup]="requestForm" class="d-flex flex-column justify-content-center align-items-center mt-4">
        <label for="type">Tipo:&nbsp;</label>
        <mat-radio-group aria-label="Tipo" formControlName="type">
          <div class="d-flex flex-column flex-lg-row recommend__pix__body--check">
            <mat-radio-button class="checkbox" value="cpf-cnpj">CPF/CNPJ</mat-radio-button>
            <mat-radio-button class="checkbox" value="phone">Celular</mat-radio-button>
            <mat-radio-button class="checkbox" value="email">E-mail</mat-radio-button>
            <mat-radio-button class="checkbox" value="key">Chave Aleatória</mat-radio-button>
          </div>
        </mat-radio-group>
        <div class="d-flex flex-column flex-lg-row justify-content-center align-items-center mt-lg-2 mt-4">
          <label for="pix" class="mb-0 mr-2">PIX:&nbsp;</label>
          <input type="text" id="pix" formControlName="pix">
          <span>Valor solicitado: R$ <input [ngModel]="(userTotal/100).toFixed(2)" type="number"
              value="{{(userTotal/100).toFixed(2)}}" step=".01" min="20.00" max="{{(userTotal/100).toFixed(2)}}"
              *ngIf="(userTotal/100) >= 20.00" formControlName="value">
            <span class="font-weight-bold ml-0" *ngIf="(userTotal/100) < 20.00">
              {{(userTotal/100).toFixed(2).toString().replace('.',',')}}
            </span> </span>
        </div>
        <div class="d-flex justify-content-center align-items-center mt-4">
          <button class="button button-green" id="request" (click)="handleForm()" [disabled]="(userTotal/100) < 20"
            type="submit">Solicitar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>